// extracted by mini-css-extract-plugin
export default {"faqs":"FAQs_faqs__fQ5FX","accordions":"FAQs_accordions__4FylZ","columnList":"FAQs_columnList__p4lhj"};